export default function PushToEhrSuccessIcon({ width = 32, height = 32, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx='16' cy='16' r='16' fill='#4C9C49' />
      <path
        d='M21.0771 11.0745L13.7202 18.4314L11.0395 15.7507C10.8191 15.5378 10.5237 15.4199 10.2172 15.4226C9.9107 15.4253 9.61748 15.5482 9.40073 15.765C9.18398 15.9817 9.06103 16.2749 9.05836 16.5815C9.0557 16.888 9.17353 17.1833 9.38649 17.4038L12.8937 20.911C13.1129 21.1301 13.4102 21.2532 13.7202 21.2532C14.0302 21.2532 14.3275 21.1301 14.5467 20.911L22.7301 12.7275C22.9431 12.507 23.0609 12.2117 23.0583 11.9052C23.0556 11.5987 22.9327 11.3055 22.7159 11.0887C22.4992 10.872 22.2059 10.749 21.8994 10.7464C21.5929 10.7437 21.2976 10.8615 21.0771 11.0745V11.0745Z'
        fill='white'
      />
    </svg>
  );
}
